import { render, staticRenderFns } from "./historicalModelManagement.vue?vue&type=template&id=d358ed72&scoped=true"
import script from "./historicalModelManagement.vue?vue&type=script&lang=js"
export * from "./historicalModelManagement.vue?vue&type=script&lang=js"
import style0 from "./historicalModelManagement.vue?vue&type=style&index=0&id=d358ed72&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d358ed72",
  null
  
)

export default component.exports